/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyB8cEOUpYL5bDxTvqxYJ7eIO4OEV1CVtJ4',
    authDomain: 'flipper-inc.firebaseapp.com',
    databaseURL: 'https://flipper-inc.firebaseio.com',
    projectId: 'flipper-inc',
    storageBucket: 'flipper-inc.appspot.com',
    messagingSenderId: '451236706701',
  },
  backendServiceURL: 'https://backend-service-standard.appspot.com',
};
